import React from "react";
import { ArrowRight } from "lucide-react";

const AboutSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <img
              src="http://res.cloudinary.com/dn6mtzcht/image/upload/v1747918267/ujnkuktky1dq5vqgq4t5.jpg"
              alt="Artisan crafting jute products"
              className="rounded-lg w-full h-auto"
            />
            {/* Decorative elements */}
            <div className="absolute -bottom-5 -right-5 bg-terracotta-100 w-full h-full rounded-lg -z-10"></div>
          </div>
          <div>
            <span className="inline-block text-terracotta-600 font-medium mb-2">Our Story</span>
            <h2 className="heading-md mb-4">Committed to Sustainable Craftsmanship</h2>
            <p className="mb-4 text-muted-foreground">
              At Jutexx, we celebrate the natural beauty and versatility of jute, one of nature's most sustainable fibers. Our journey began with a simple mission: to create beautiful, functional home goods that honor traditional craftsmanship while promoting environmental stewardship.
            </p>
            <p className="mb-6 text-muted-foreground">
              Each piece in our collection is handcrafted by skilled artisans who transform raw jute fibers into durable, beautiful products that bring warmth and texture to your home. By choosing our products, you're not only enhancing your living space but also supporting sustainable practices and artisan communities.
            </p>
            {/* <a href="/about" className="btn-primary flex items-center max-w-fit">
              <span>Learn More</span>
              <ArrowRight size={18} className="ml-2" />
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;